import { Link } from 'react-router-dom';
import img from '../img/katrina-wright-cropunsplash_450.jpg';

export default function Resources() {
  return (
    <div>
      <div className="hero-resource">
        <div id="hero">
          <img
            className="hero-img"
            src={img}
            alt="Photo credit: Katrina Wright via Unsplash"
            title="Photo credit: Katrina Wright via Unsplash"
          />
        </div>
      </div>

      <div className="container resources">
        <h1>Resources</h1><br />

        <div className="even-columns about p-flow">
        <h3>Aphasia Simulations</h3>
        <div className="card">
          <p>
            Aphasia Simulations developed by Dr. Hinckley at Nova University, and Keen Research.
            The purpose of these simulations is to provide some activities that can help you
            understand what it might be like to have aphasia:{' '}
            <span className="no_padding">
              <Link to="http://www.vohaphasia.org/simulation/" target="_blank" rel="noopener noreferrer">
                Aphasia Simulations
              </Link>.
            </span>
            <br />
          </p>
        </div>

        <h3>Supported Conversation for PWA (SCA™)</h3>
        <div className="card">
          <p>
            Developed by Aphasia Institute of Toronto
            <br />
            The goals of SCA™ are:
            <br />
            • Acknowledge the competence of the PWA. <br />
            • Help the PWA to reveal his or her competence. <br />
            •{' '}
            <Link
              to="https://www.aphasia.ca/family-and-friends-of-people-with-aphasia/family-sca/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Talking to to your family member: Conversation Basics
            </Link>
            <br />
            <br />
            SCA™ is a communication method that uses a set of techniques to encourage conversation
            when working with PWA.{' '}
            <Link
              to="https://www.aphasia.ca/communication-tools-communicative-access-sca/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Supported Conversation tools
            </Link>.
          </p>
        </div>

        <h3>The Pictographs</h3>
        <div className="card">
          <p>
            ParticiPics is a free, searchable database of pictographic images designed to facilitate
            life's conversations. The pictographs are specially designed for communicating with PWA
            and the product of decades of research and experience with people in the aphasia and
            stroke communities.
            <br />
            ParticiPics is now hosted on the{' '}
            <Link
              to="https://www.aphasia.ca/participics/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Aphasia Institute Community Hub
            </Link>.
          </p>
        </div>

        <h3>Neuroplasticity</h3>
        <div className="card">
          <p>
            The brain possesses the remarkable capacity to reorganize pathways, create new
            connections, and, in some cases, even create new neurons - a concept called
            neuroplasticity or brain plasticity.
            <br />
            •{' '}
            <Link to="https://www.verywellmind.com/what-is-brain-plasticity-2794886">
              What Is Neuroplasticity?
            </Link>{' '}
            article.
            <br />
            • Sentis animation on{' '}
            <Link
              to="https://www.youtube.com/watch?v=ELpfYCZa87g"
              target="_blank"
              rel="noopener noreferrer"
            >
              Neuroplasticity
            </Link>.
            <br />
            •{' '}
            <Link to="/newsletters/Neuroplasticity.pdf" target="_blank" rel="noopener noreferrer">
              Neuroplasticity PDF
            </Link>
          </p>
        </div>

        <div>
          <h3>The Growth Mindset</h3>
          <p>
            There are emotional impacts from the trauma of stroke and aphasia. After the trauma,
            there is a feeling of loss, from physical changes, changes in language abilities, and
            changes in community and social roles. The loss leads to grieving and can become chronic
            grieving. The emotional impacts can affect communication abilities.
            <br />
            Adopting a growth mindset can help process the trauma and positively affect recovery.
            Engage in the process of improving.
          </p>
          <p>
            <u>Read</u>:
            <br />
            <Link to="https://medium.com/@coyboggs/keeping-a-growth-mindset-in-trauma-8ccd47fd9930" target="_blank" rel="noopener noreferrer">
              Keeping a Growth Mindset in Trauma
            </Link>
            <br />
            <Link to="https://www.lifteducation.com/growth-mindset-for-adult-learners/" target="_blank" rel="noopener noreferrer">
              Growth Mindset for Adult Learners
            </Link>
            <br />
            <Link to="https://strokeonward.org/guide/" target="_blank" rel="noopener noreferrer">
              Emotional Journey in Stroke Recovery
            </Link>
          </p>
          <p>
            <u>Watch</u>:{' '}
            <Link to="https://youtu.be/J-swZaKN2Ic?si=00FPH5O7WUKsNxPN" target="_blank" rel="noopener noreferrer">
              The power of yet | Carol S Dweck | TEDxNorrköping
            </Link>
          </p>
          <div className="youtube">
            <iframe
              width="100%"
              height="439"
              style={{ maxWidth: '780px', aspectRatio: '16/9', height: 'auto' }}
              src="https://www.youtube.com/embed/J-swZaKN2Ic?si=nenscyzFa4hrw1i5"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        <div>
          <h3>Brain Friends Podcast</h3>
          <p>
            The Brain Friends podcast is a space for neuro nerds and stroke survivors to talk about
            all things aphasia, language recovery, and community. Hosted by Dr. D. Seles Gadson, a
            neuroscientist and speech-language pathologist, and Angie C., 2x stroke survivor and
            aphasia advocate. Listen, laugh, and learn with these two stakeholders determined to
            make a difference in aphasia advocacy.
            <br />
            Listen or download the podcast here:{' '}
            <Link
              to="https://podcasts.apple.com/us/podcast/brain-friends/id1631036407?i=1000658716836"
              target="_blank"
              rel="noopener noreferrer"
            >
              LINK
            </Link>
          </p>
        </div>

        <br />
        <h3>Aphasia Games for Health</h3>
        <div className="card">
          <p>
            A collaboration between professional game designers, academic speech pathologists and
            the aphasia community to develop games that best serve the needs of the aphasia
            community.
          </p>
          <ul>
            <li>The Ministers Cat: A memory and letter game for 2-6 players.</li>
            <li>Audition: A memory and improv-game.</li>
            <li>
              Do You See What I See: A video chat game for 4-16 players combining storytelling
              and 20 questions.
            </li>
          </ul>
          <p>
            Aphasia Community Recommendations:{' '}
            <Link
              to="https://www.aphasiagamesforhealth.com/community-recs"
              target="_blank"
              rel="noopener noreferrer"
            >
              Aphasia Games for Health
            </Link>.
          </p>
        </div>

        </div>{/* even-columns */}
      </div>{/* container */}
    </div>
  );
}
